import { ANOMALY_ATTRIBUTES } from './inspections';

export enum ANOMALY_TABLE_TYPES {
    PIVOT = 'Pivot',
    TABULAR = 'Tabular',
}

export const ANOMALIES_PAGE_TABLE_TABS = [ANOMALY_TABLE_TYPES.PIVOT, ANOMALY_TABLE_TYPES.TABULAR];

export const HIDDEN_PIVOT_ANOMALY_ATTRIBUTES = [
    ANOMALY_ATTRIBUTES.IR_ANOMALY,
    ANOMALY_ATTRIBUTES.RGB_ANOMALY,
    ANOMALY_ATTRIBUTES.PRIORITY_LEVEL,
    ANOMALY_ATTRIBUTES.POWER_LOSS,
    ANOMALY_ATTRIBUTES.LONGITUDE,
    ANOMALY_ATTRIBUTES.LATITUDE,
    ANOMALY_ATTRIBUTES.POWER_LOSS,
    ANOMALY_ATTRIBUTES.ENERGY_LOSS_WEIGHT,
    ANOMALY_ATTRIBUTES.POSITION_ID,
    ANOMALY_ATTRIBUTES.IR_IMAGE_URL,
    ANOMALY_ATTRIBUTES.RGB_IMAGE_URL,
    ANOMALY_ATTRIBUTES.ANOMALY_TEMP,
    ANOMALY_ATTRIBUTES.BASE_TEMP,
    ANOMALY_ATTRIBUTES.TEMP_DELTA,
    ANOMALY_ATTRIBUTES.SERIAL_NUMBER,
];

export enum PivotViewOptions {
    ANOMALY_SUMMARY = 'Anomaly Summary',
    REMEDIATION_RECOMMENDED = 'Remediation Recommended',
    MONITOR_AND_REMEDIATE = 'Monitor and Remediate',
    LONG_TERM_MONITORING = 'Long Term Monitoring',
    REMEDIATION_BY_SUBSYSTEM = 'Remediation by Subsystem',
    CUSTOM = 'Custom',
    DIFFERENTIAL_SUMMARY = 'Overall Differential Counts',
    DIFFERENTIAL_REMEDIATION_CATEGORIES = 'Differential by Remediation',
    DIFFERENTIAL_SUBSYSTEM = 'Differential by Subsystem',
    OLDER_INSPECTION = 'Older Inspection',
    NEWER_INSPECTION = 'Newer Inspection',
}

export const INSPECTION_TABLE_COLORS = {
    lightBlue: '#CAF2FF',
    darkBlue: '#02669D',
    offWhite: '#F5F5F5',
    lightGrey: '#4F4F4F',
    darkGrey: '#4A4A4A',
};

export const DEFAULT_PIVOT_VIEW_OPTIONS = [
    PivotViewOptions.ANOMALY_SUMMARY,
    PivotViewOptions.REMEDIATION_RECOMMENDED,
    PivotViewOptions.MONITOR_AND_REMEDIATE,
    PivotViewOptions.LONG_TERM_MONITORING,
    PivotViewOptions.REMEDIATION_BY_SUBSYSTEM,
    PivotViewOptions.CUSTOM,
];

export const DIFFERENTIAL_PIVOT_VIEW_OPTIONS = [
    PivotViewOptions.DIFFERENTIAL_SUMMARY,
    PivotViewOptions.DIFFERENTIAL_REMEDIATION_CATEGORIES,
    PivotViewOptions.DIFFERENTIAL_SUBSYSTEM,
    PivotViewOptions.OLDER_INSPECTION,
    PivotViewOptions.NEWER_INSPECTION,
    PivotViewOptions.CUSTOM,
];

export const DISABLED_PIVOT_VIEW_OPTIONS_FOR_FSX = [
    PivotViewOptions.MONITOR_AND_REMEDIATE,
    PivotViewOptions.LONG_TERM_MONITORING,
];

export const CORE_PIVOT_TABLE_SETTING_PROPERTY_KEYS = ['rows', 'cols', 'valueFilter'];

export const FILTERED_EMPTY_ANOMALY_ATTRIBUTES = [ANOMALY_ATTRIBUTES.COMBINER_ID, ANOMALY_ATTRIBUTES.INVERTER_ID];

export const HIDDEN_CSV_FIELDS = [ANOMALY_ATTRIBUTES.UUID];
